import { useMemo } from "react";
import { usePreset } from "../../../PresetContext";

export const useCalendarHightlightFeature = () => {
    const { mode } = usePreset();

    const calendarHighlightFeature = useMemo (() => ({
        calendar: "resource",
        unhighlightOnDrop: "resource",
    }), []);

    return useMemo(() => {
        if (mode === "date" || !mode || mode === null) {
            return calendarHighlightFeature;
        } else {
            return false;
        }
    }, [mode, calendarHighlightFeature]);
}
